export const Legend: React.FC = () => {
    return null;
};
